import { io } from "socket.io-client";

export const connectSocket = () => {
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const socketUrl = isLocal ? undefined : "https://iq-doctor-backend-expnckkt5a-ey.a.run.app";
  return io(socketUrl);
};
